var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-table-column',{attrs:{"prop":_vm.col.prop,"label":_vm.col.label,"align":_vm.alignType}},[_vm._l((_vm.col.children),function(item,index){return [(item.children)?_c('column-item',{key:index,attrs:{"col":item}}):_c('el-table-column',{key:index,attrs:{"label":item.label,"prop":item.prop,"align":_vm.alignType}})]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72dc4f8a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/columnItem.vue
// module id = null
// module chunks = 